/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".svi-question-container[_ngcontent-%COMP%]{padding:20px}.svi-question-container[_ngcontent-%COMP%]   .category[_ngcontent-%COMP%]{margin-bottom:10px}.svi-question-container[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{line-height:1.25;min-height:8.75em}@media (min-width:768px){.svi-question-container[_ngcontent-%COMP%]{padding:20px 80px}.svi-question-container[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:24px;min-height:5em}}.svi-question-container[_ngcontent-%COMP%]   .more-info-placeholder[_ngcontent-%COMP%]{height:36px}"];
export { styles as styles };
